import React, { useState } from 'react'
import { Box, Button, CircularProgress, Container, Paper, Stack, TextField, Typography, Alert, Checkbox, FormControlLabel } from '@mui/material'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'
import { axiosi } from '../config/axios'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectLoggedInUser } from '../features/auth/AuthSlice'

export const DiscountCreatePage = () => {
  const [formData, setFormData] = useState({
    code: '',
    discountPercentage: '',
    expiresAt: '',
    usageLimit: '',
    isActive: true
  })
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState({ type: '', text: '' })
  const navigate = useNavigate()
  const loggedInUser = useSelector(selectLoggedInUser)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage({ type: '', text: '' })

    try {
      if (!formData.code || !formData.discountPercentage) {
        setMessage({ type: 'error', text: 'Please fill all required fields' })
        setLoading(false)
        return
      }

      await axiosi.post('/coupons', {
        ...formData,
        code: formData.code.toUpperCase()
      }, {
        headers: {
          Authorization: `Bearer ${loggedInUser?.token}`
        }
      })

      setMessage({ type: 'success', text: 'Discount code created successfully!' })
      setTimeout(() => {
        navigate('/admin/dashboard')
      }, 2000)
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Error creating discount code'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Navbar />
      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
            🏷️ Create Discount Code
          </Typography>

          {message.text && (
            <Alert severity={message.type} sx={{ mb: 2 }}>
              {message.text}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                fullWidth
                label="Coupon Code"
                name="code"
                placeholder="SAVE20"
                value={formData.code}
                onChange={handleChange}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                helperText="Enter unique code (will be converted to uppercase)"
              />

              <TextField
                fullWidth
                label="Discount Percentage"
                name="discountPercentage"
                type="number"
                placeholder="20"
                value={formData.discountPercentage}
                onChange={handleChange}
                inputProps={{ min: 1, max: 100 }}
                helperText="Enter discount percentage (1-100)"
              />

              <TextField
                fullWidth
                label="Expires At"
                name="expiresAt"
                type="datetime-local"
                value={formData.expiresAt}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />

              <TextField
                fullWidth
                label="Usage Limit"
                name="usageLimit"
                type="number"
                placeholder="100"
                value={formData.usageLimit}
                onChange={handleChange}
                inputProps={{ min: 1 }}
                helperText="Maximum times this code can be used"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="isActive"
                    checked={formData.isActive}
                    onChange={handleChange}
                  />
                }
                label="Active (Customers can use this code)"
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} /> : null}
              >
                {loading ? 'Creating...' : 'Create Discount Code'}
              </Button>

              <Button
                variant="outlined"
                onClick={() => navigate('/admin/dashboard')}
              >
                Back to Admin Panel
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Container>
      <Footer />
    </>
  )
}
